export const translations = {
  it: {
    nav: {
      links: [
        { key: "ecosystem", label: "Ecosistema", href: "#manifesto" },
        { key: "apps", label: "Applicazioni", href: "#apps" },
        { key: "contacts", label: "Contatti", href: "#footer" },
      ],
      whatsapp: "Parla con noi",
    },
    hero: {
      kicker: "Rexxpons Network · Galano & Partners",
      headline: [
        { plain: "Intelligenza ", accent: "cognitiva." },
        { plain: "Autorevolezza ", accent: "legale." },
        { plain: "Un solo ", accent: "ecosistema." },
      ],
      subtitle:
        "Nove applicazioni avanzate che fondono AI cognitiva di ultima generazione e strumenti legal-tech, progettate per anticipare, analizzare e decidere.",
      ctaExplore: "Esplora l'ecosistema",
      ctaManifesto: "Scopri la visione",
      stats: [
        ["09", "Applicazioni"],
        ["AI", "Cognitiva"],
        ["24/7", "Operatività"],
      ],
      scroll: "Scorri",
    },
    manifesto: {
      caption: "Il Manifesto",
      captionTitle: "Tecnologia al servizio del diritto.",
      heading: "Un ecosistema costruito su tre convinzioni.",
      chapters: [
        {
          num: "01",
          title: "Cognizione",
          body:
            "Ogni strumento pensa con te. L'AI di Rexxpons interpreta contesto e intento, trasformando dati grezzi in intuizioni operative immediate.",
        },
        {
          num: "02",
          title: "Diritto",
          body:
            "Dalla consulenza vocale alla redazione degli atti, il legal-tech Rexxpons affianca il professionista in ogni fase del lavoro giuridico.",
        },
        {
          num: "03",
          title: "Fiducia",
          body:
            "Due diligence approfondita e verifiche reputazionali immediate: decidi con partner e aziende in totale sicurezza e trasparenza.",
        },
      ],
    },
    apps: {
      caption: "Le Applicazioni",
      heading1: "Nove strumenti.",
      heading2: "Un'unica intelligenza.",
      intro:
        "Ogni applicazione è un dominio operativo autonomo, connesso all'intero ecosistema Rexxpons. Selezionane una per accedere alla piattaforma dedicata.",
      items: {
        "browser-cognitivo": {
          category: "AI Cognitiva",
          name: "Browser Cognitivo Rexxpons",
          description:
            "Navigazione web intelligente e context-aware, potenziata dall'AI per anticipare le esigenze di ricerca e analisi.",
        },
        "motore-ricerca": {
          category: "AI Cognitiva",
          name: "Motore di Ricerca Cognitivo",
          description:
            "Motore di ricerca semantico avanzato che interpreta il significato profondo dei dati, oltre le semplici parole chiave.",
        },
        "analisi-bilancio": {
          category: "Finanza",
          name: "Analisi di Bilancio & Business Plan",
          description:
            "Strumenti finanziari di precisione per analizzare la salute aziendale, valutare i rischi e prevedere le performance economiche.",
        },
        "business-plan": {
          category: "Finanza",
          name: "Business Plan",
          description:
            "Piattaforma intuitiva e professionale per strutturare, sviluppare e presentare business plan con metriche impeccabili.",
        },
        "assistenza-vocale": {
          category: "Legal Tech",
          name: "Assistenza Legale Vocale",
          description:
            "Consulenza legale a comando vocale e supporto rapido per risposte mirate, in tempo reale.",
        },
        "redazione-avvocato": {
          category: "Legal Tech",
          name: "Assistenza Redazione Attività Avvocato",
          description:
            "Co-pilota digitale per i professionisti del diritto: velocizza la redazione di atti, documenti e pareri.",
        },
        "due-diligence": {
          category: "Reputazione",
          name: "Verifica Reputazione — Due Diligence Approfondita",
          description:
            "Analisi reputazionale rigorosa e due diligence completa per verificare a fondo partner e aziende.",
        },
        "reputazione-rapida": {
          category: "Reputazione",
          name: "Verifica Reputazione Rapida",
          description:
            "Controlli reputazionali online immediati e mirati per decisioni rapide, sicure e informate.",
        },
        "comunicazione-avanzata": {
          category: "Comunicazione",
          name: "Sistema di Comunicazione Avanzato",
          description:
            "Piattaforma di comunicazione sicura di nuova generazione: gestisce flussi vocali e digitali senza confini.",
        },
      },
    },
    footer: {
      brandKicker: "Rexxpons Network",
      headline1: "Costruiamo il futuro",
      headline2: "di diritto e impresa.",
      byLabel: "A cura di",
      firm: "Galano & Partners",
      firmSub: "Law Firm",
      contactsLabel: "Contatti",
      assistLabel: "Assistenza rapida",
      whatsapp: "Chat on WhatsApp",
      pec: "PEC",
      rights:
        "Rexxpons Network — Galano & Partners Law Firm. Tutti i diritti riservati.",
      tagline: "Ecosistema cognitivo & legal-tech",
    },
  },

  en: {
    nav: {
      links: [
        { key: "ecosystem", label: "Ecosystem", href: "#manifesto" },
        { key: "apps", label: "Applications", href: "#apps" },
        { key: "contacts", label: "Contacts", href: "#footer" },
      ],
      whatsapp: "Talk to us",
    },
    hero: {
      kicker: "Rexxpons Network · Galano & Partners",
      headline: [
        { plain: "Cognitive ", accent: "intelligence." },
        { plain: "Legal ", accent: "authority." },
        { plain: "One ", accent: "ecosystem." },
      ],
      subtitle:
        "Nine advanced applications merging next-generation cognitive AI and legal-tech, built to anticipate, analyze and decide.",
      ctaExplore: "Explore the ecosystem",
      ctaManifesto: "Discover the vision",
      stats: [
        ["09", "Applications"],
        ["AI", "Cognitive"],
        ["24/7", "Uptime"],
      ],
      scroll: "Scroll",
    },
    manifesto: {
      caption: "The Manifesto",
      captionTitle: "Technology in service of the law.",
      heading: "An ecosystem built on three convictions.",
      chapters: [
        {
          num: "01",
          title: "Cognition",
          body:
            "Every tool thinks with you. Rexxpons AI interprets context and intent, turning raw data into immediate operational insight.",
        },
        {
          num: "02",
          title: "Law",
          body:
            "From voice consultation to drafting acts, Rexxpons legal-tech supports the professional at every stage of legal work.",
        },
        {
          num: "03",
          title: "Trust",
          body:
            "In-depth due diligence and instant reputation checks: decide on partners and companies in complete safety and transparency.",
        },
      ],
    },
    apps: {
      caption: "The Applications",
      heading1: "Nine tools.",
      heading2: "One intelligence.",
      intro:
        "Each application is an autonomous operational domain, connected to the entire Rexxpons ecosystem. Select one to access its dedicated platform.",
      items: {
        "browser-cognitivo": {
          category: "Cognitive AI",
          name: "Rexxpons Cognitive Browser",
          description:
            "Intelligent, context-aware web browsing, powered by AI to anticipate research and analysis needs.",
        },
        "motore-ricerca": {
          category: "Cognitive AI",
          name: "Cognitive Search Engine",
          description:
            "Advanced semantic search engine that interprets the deep meaning of data, beyond simple keywords.",
        },
        "analisi-bilancio": {
          category: "Finance",
          name: "Financial & Business Plan Analysis",
          description:
            "Precision financial tools to analyze corporate health, assess risk and forecast economic performance.",
        },
        "business-plan": {
          category: "Finance",
          name: "Business Plan",
          description:
            "An intuitive, professional platform to structure, develop and present business plans with flawless metrics.",
        },
        "assistenza-vocale": {
          category: "Legal Tech",
          name: "Voice Legal Assistance",
          description:
            "Voice-driven legal advice and rapid support for targeted, real-time answers.",
        },
        "redazione-avvocato": {
          category: "Legal Tech",
          name: "Lawyer Drafting Assistant",
          description:
            "A digital co-pilot for legal professionals: speeds up drafting of acts, documents and opinions.",
        },
        "due-diligence": {
          category: "Reputation",
          name: "Reputation Check — In-depth Due Diligence",
          description:
            "Rigorous reputational analysis and full due diligence to thoroughly verify partners and companies.",
        },
        "reputazione-rapida": {
          category: "Reputation",
          name: "Fast Reputation Check",
          description:
            "Immediate, targeted online reputation checks for quick, secure and informed decisions.",
        },
        "comunicazione-avanzata": {
          category: "Communication",
          name: "Advanced Communication System",
          description:
            "Next-generation secure communication platform: manages voice and digital streams without borders.",
        },
      },
    },
    footer: {
      brandKicker: "Rexxpons Network",
      headline1: "We build the future",
      headline2: "of law and business.",
      byLabel: "Curated by",
      firm: "Galano & Partners",
      firmSub: "Law Firm",
      contactsLabel: "Contacts",
      assistLabel: "Quick assistance",
      whatsapp: "Chat on WhatsApp",
      pec: "PEC",
      rights:
        "Rexxpons Network — Galano & Partners Law Firm. All rights reserved.",
      tagline: "Cognitive & legal-tech ecosystem",
    },
  },
};
